import { useState, FC, Fragment } from "react";
import { ReactComponent as ExitIcon } from "@images/exit_icon.svg";
import { useHotkeys } from "react-hotkeys-hook";
import IconButton from "@components/common/IconButton";
import Alert, { AlertState } from "@components/common/Alert";
import { Dialog, Transition } from "@headlessui/react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LoadingSpinner } from "@images/loading_spinner.svg";
import { OBPersonaAnswerKey } from "@models/Enums";
import house from "@images/onb_let_4.png";
import newspaper from "@images/onb_let_6.png";
import mug from "@images/onb_let_7.png";
import graph from "@images/onb_let_8.png";
import bullseye from "@images/bullseye.png";

interface PopUpModalProps {
	isShow: boolean;
    setIsShow: (isShow: boolean) => void;
    image: string;
    title: string;
    description: string;
    actionTitle: string;
}   

const PopUpModal: FC<PopUpModalProps> = ({ isShow, setIsShow, image, title, description, actionTitle }) => {
	const [alertState, setAlertState] = useState<AlertState>({
		isShow: null,
		title: null,
		message: null,
		actionButton: null,
		dismissButton: null,
		actionButtonAction: undefined,
	});
	const navigate = useNavigate();

	return (
		<>
			<Alert alertState={alertState} setAlertState={setAlertState} />
			<Transition as={Fragment} show={isShow}>
				<Dialog onClose={() => setIsShow(false)} className="relative z-40">
					<Transition.Child as="div" enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
						<div className="fixed inset-0 bg-black bg-opacity-70" aria-hidden="true" />
					</Transition.Child>
					<div className="fixed inset-0 flex w-screen items-center justify-center p-4">
						<Transition.Child enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
							<Dialog.Panel className="max-w-[400px] transform overflow-hidden rounded-2xl bg-white border border-black/10 text-center align-middle shadow-xl transition-all p-4">
								<div className="flex flex-col gap-2">
                                    <img src={image} className="w-[150px] m-auto object-cover" />
									<div className="text-brand-blue font-black font-primary text-xl whitespace-pre-line">{title}</div>
									<div className="text-black/50 font-regular font-primary text-sm">{description}</div>
                                    <button className={`opacity-100 hover:bg-success-green/80 text-white font-medium font-primary text-base focus:outline-none rounded-full p-2 px-3 py-3 items-center bg-success-green transition ease-in-out whitespace-nowrap mt-3`} onClick={() => setIsShow(false)}>{actionTitle}</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
		</>
	);
};

export default PopUpModal;